import { useQueryClient, type MutationFunction } from "@tanstack/react-query";
import { useHTTP, useHTTPMutation, type HTTPResponse } from "@/lib/http";

export interface ConfirmImportResponseModel {
	readonly collectionId: string;
}

export const useConfirmImport = () => {
	const http = useHTTP("Required");
	const queryClient = useQueryClient();

	const mutationFn: MutationFunction<HTTPResponse<ConfirmImportResponseModel>, string> = async importId => {
		return http<ConfirmImportResponseModel>({
			method: "POST",
			url: `/import/${importId}/confirm`,
			body: undefined
		});
	};

	return useHTTPMutation({
		mutationFn,
		onSuccess: data => {
			queryClient.invalidateQueries({ queryKey: ["importStatus"] });
			queryClient.invalidateQueries({ queryKey: ["collections"] });
			queryClient.invalidateQueries({ queryKey: ["collectionsPerformanceDelta"] });
			queryClient.invalidateQueries({ queryKey: ["collection", data.body.collectionId] });
			queryClient.invalidateQueries({ queryKey: ["collectionHistoricalPositions", data.body.collectionId] });
			queryClient.invalidateQueries({ queryKey: ["transactions"] });
			queryClient.invalidateQueries({ queryKey: ["transactionSummaries"] });
			queryClient.invalidateQueries({ queryKey: ["dashboardCurrentPosition"] });
			queryClient.invalidateQueries({ queryKey: ["dashboardHistoricalPositions"] });
			queryClient.invalidateQueries({ queryKey: ["dashboardPerformanceDeltas"] });
		}
	});
};
